<div
  class="c-icon"
  [class]="classes.join(' ')"></div>
